<!-- 品名管理编辑-->
<template>
  <div style="margin-bottom: 30px">
    <el-row>
      <el-col :xs="6" :sm="6">
        <el-button type="primary" size="mini" @click="doDownloadTpl"><i
            class="el-icon-download"></i><span>{{ msg('下载模板') }}</span></el-button>
      </el-col>
      <el-col :xs="6" :sm="6">
        <el-button size="mini"
                   @click="doSelectFile()" type="success"
                   style="margin-right:5px; margin-bottom:5px;">
          <i class="el-icon-upload2"></i>
          <transition name="el-fade-in-linear">
            <span>{{ msg('上传文件') }}</span>
          </transition>
        </el-button>
        <div ref="fileArea" style="display:none;">
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :xs="48" :sm="48">
        <span style="color: lightcoral">温馨提示：品名重复时将更新替代名，同一批次导入的数据中多条重复的品名将以第一条为准！</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "productNameImport",
  components: {},
  data() {
    return {
      excelTitles: ['序号', '品名', '替代名']
    }
  },
  mounted() {
  },
  methods: {
    doDownloadTpl() {  //下载一个excel模板，
      var titles = [this.excelTitles, ['', '', '', '', '', '']];

      var filename = this.msg('品名导入模板') + '.xlsx';

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(titles);

      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, filename);
    },
    doSelectFile() {  //点击选择文件
      this.$refs.fileArea.innerHTML = "";
      var input = document.createElement("input");
      input.type = "file";
      input.setAttribute("accept", ".xls,.xlsx");
      var _this = this;
      input.onchange = this.getUploadFile;
      this.$refs.fileArea.appendChild(input);
      input.click();
    },
    getUploadFile(e) {  //解析上传的excel
      let that = this;

      this.excelData = null
      //拿到所导入文件的名字
      let fileName = e.target.files[0];
      //定义reader，存放文件读取方法
      let reader = new FileReader();
      //启动函数
      reader.readAsBinaryString(fileName)
      //onload在文件被读取时自动触发
      reader.onload = (e) => {
        //workbook存放excel的所有基本信息
        let workbook = XLSX.read(e.target.result, {type: 'binary'})
        //存放json数组格式的表格数据
        let worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let json = XLSX.utils.sheet_to_json(worksheet, {header: 1})

        var heads = json[0];
        var flag = false;
        for (var i = 0; i < that.excelTitles.length; i++) {
          var item = that.excelTitles[i];
          if (!heads.includes(item)) {
            flag = true;
            break;
          }
        }
        if (flag) {
          that.$message.error(that.msg("上传失败，模板不正确"));
          return;
        }

        that.excelData = json.splice(1);
        that.excelHeads = heads;
        that.$refs.fileArea.innerHTML = "";
        this.doUpload();
      };
    },
    doUpload() {
      var _this = this;
      this.$axios.post(this.$kit.api.simpleProductName.import, this.excelData)
          .then((result) => {
            if (result.status) {
              if (result.data) {
                this.$message.success(this.msg("导入成功，新增" + result.data.addCount + "条，更新" + result.data.updateCount + "条"));
              } else {
                this.$message.error(this.msg("导入失败"));
              }
            } else {
              this.$message.error(result.msg);
            }
          });
    },

  }

}
</script>

<style lang="scss" scoped>

</style>